import React, {useEffect, useContext, useState} from "react"
import PropTypes from "prop-types"

import { AppContext } from "../components/context/AppContext"
import { OfferApi } from "../utils/api"

import { MaintenanceModeComponent, PageNotFound } from "../components"
import { AAAPromoGetStartedComponent, AAAPromoWelcomeComponent } from "../components/AAAPromo"
import AnalyticsService from "../utils/AnalyticsService"
import { ROUTE_PATHS } from "../utils/routes"
import { PROMO_CUSTOM_LANDING_PAGE_VIEW } from "../utils/GA4Events"

const offerId = Number.parseInt(process.env.REACT_APP_AAA_OFFER_ID)

export const AAAPromo = () => {
  const {dispatch, state} = useContext(AppContext)
  const [inMaintenanceMode, setInMaintenanceMode] = useState(true)
  const [maintenanceText, setMaintenanceText] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const [isErrorFetchingMaintenanceText, setIsErrorFetchingMaintenanceText] = useState(false)
  const [isPageNotFound, setIsPageNotFound] = useState(false)
 

  useEffect(() => {
    AnalyticsService.sendUniquePageview(ROUTE_PATHS.AAA);
    AnalyticsService.sendGA4FunnelEvent(PROMO_CUSTOM_LANDING_PAGE_VIEW, {
      page_path: ROUTE_PATHS.AAA,
      partner_name: "AAA"
    });
    dispatch({type: "RESETUSER"})
  }, [dispatch])

  useEffect(() => {
    const checkMaintenanceMode = async () => {

      setIsLoading(true)
      try {
        const clientMaintenanceFlagResult = await OfferApi.getClientAsset("MaintenanceFlag")
        const clientMaintenanceText = await OfferApi.getClientAsset("MaintenanceText")
        const pageNotFound = await OfferApi.getOfferAsset(offerId ,"PAGE_NOT_FOUND")
        setIsPageNotFound(pageNotFound)
        if (clientMaintenanceFlagResult.notes.toLowerCase() === "true") {
          setMaintenanceText(clientMaintenanceText.notes)
          setIsLoading(false)
          return
        }

        const offerMaintenanceFlag = await OfferApi.getOfferAsset(offerId, "MaintenanceFlag")
        const offerMaintenanceText = await OfferApi.getOfferAsset(offerId, "MaintenanceText")

        if (offerMaintenanceFlag.notes && offerMaintenanceFlag.notes.toLowerCase() === "true") {
          setMaintenanceText(offerMaintenanceText.notes)
          setIsLoading(false)
          return
        }

        setInMaintenanceMode(false)
      } catch (error) {
        if (error.message === "Unable to retrieve client asset") {
          setIsErrorFetchingMaintenanceText(true)
        }
        setErrorMessage("Something went wrong. Please try again.")
      } finally {
        setIsLoading(false)
      }
    }

    checkMaintenanceMode()
  }, [inMaintenanceMode])

  const ActiveContent = () => (
    <>
      {!isPageNotFound && <AAAPromoGetStartedComponent errorMessage={state.commonError} offerId={offerId} setErrorMessage={setErrorMessage} />}
    </>)

  return (
    <>
    <AAAPromoWelcomeComponent />
    {isPageNotFound &&  <PageNotFound/>}
    {isErrorFetchingMaintenanceText &&
    <div className="text-center container">
      <h1 className="magenta">Temporarily Unavailable</h1>
      <p>This site is currently under going scheduled maintenance. We&apos;ll be back soon.</p>
      <p> Thank you for your patience.</p>
    </div> }
    {isLoading && <div style={{textAlign: "center"}}>Loading ...</div>}
    {errorMessage.length > 0 && !isLoading && !isErrorFetchingMaintenanceText && <div style={{textAlign: "center"}}>{errorMessage}</div>}
    {inMaintenanceMode && !isLoading && <MaintenanceModeComponent maintenanceText={maintenanceText} />}
    {!inMaintenanceMode && !isLoading && !isErrorFetchingMaintenanceText && <ActiveContent /> }
    </>
  )
}

AAAPromo.propTypes = {
  history: PropTypes.object
}
